export default __webpack_public_path__ + "static/media/aerial_landmark.8608cfd7.svg";